import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import Login from './Login';
import CareRecordForm from './CareRecordForm';
import RecordsList from './RecordsList';
import AnalyticsComponent from './Analytics';
import ThemeSelector from './ThemeSelector';
import { ToastContainer } from 'react-toastify';

export default function SimpleApp() {
  const { currentUser, logout } = useAuth();
  const [activeTab, setActiveTab] = useState(0);
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const [loading, setLoading] = useState(false);

  const handleRecordSaved = () => {
    setRefreshTrigger(prev => prev + 1);
  };

  const handleLogout = async () => {
    try {
      await logout();
    } catch (error) {
      console.error('ログアウトエラー:', error);
    }
  };

  if (!currentUser) {
    return <Login />;
  }

  const tabs = [
    { id: 0, name: '記録追加', icon: '➕' },
    { id: 1, name: '記録一覧', icon: '📋' },
    { id: 2, name: '分析', icon: '📊' },
  ];

  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#f8fffe', fontFamily: 'system-ui, sans-serif' }}>
      {/* ヘッダー */}
      <div style={{ 
        backgroundColor: 'rgba(255, 255, 255, 0.9)', 
        padding: '1rem', 
        marginBottom: '1.5rem',
        borderRadius: '0 0 1.5rem 1.5rem',
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
      }}>
        <div style={{ maxWidth: '64rem', margin: '0 auto', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <div style={{ 
              width: '3rem', 
              height: '3rem', 
              background: 'linear-gradient(135deg, #66bb6a, #42a5f5)',
              borderRadius: '1rem',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '1.5rem',
              marginRight: '0.75rem'
            }}>
              🧘
            </div>
            <div>
              <h1 style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#1a202c', margin: 0 }}>セルフケア記録</h1>
              <p style={{ fontSize: '0.875rem', color: '#4a5568', margin: 0 }}>{currentUser.email}</p>
            </div>
          </div>
          
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
            <ThemeSelector />
            <button
              onClick={handleLogout}
              style={{
                backgroundColor: 'rgba(255, 255, 255, 0.8)',
                padding: '0.75rem',
                borderRadius: '0.75rem',
                border: 'none',
                color: '#4a5568',
                cursor: 'pointer',
                transition: 'all 0.3s ease'
              }}
            >
              ログアウト
            </button>
          </div>
        </div>
      </div>

      <div style={{ maxWidth: '64rem', margin: '0 auto', padding: '0 1rem' }}>
        {/* タブナビゲーション */}
        <div style={{ 
          backgroundColor: 'rgba(255, 255, 255, 0.9)',
          borderRadius: '1.5rem',
          padding: '0.5rem',
          marginBottom: '1.5rem',
          boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
        }}>
          <div style={{ display: 'flex', gap: '0.5rem' }}>
            {tabs.map((tab) => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                style={{
                  flex: 1,
                  padding: '0.75rem 1rem',
                  borderRadius: '1rem',
                  border: 'none',
                  fontWeight: '600',
                  transition: 'all 0.3s ease',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '0.5rem',
                  background: activeTab === tab.id 
                    ? 'linear-gradient(135deg, #66bb6a, #42a5f5)' 
                    : 'transparent',
                  color: activeTab === tab.id ? 'white' : '#4a5568',
                  transform: activeTab === tab.id ? 'scale(1.05)' : 'scale(1)',
                  boxShadow: activeTab === tab.id ? '0 4px 12px rgba(102, 187, 106, 0.3)' : 'none'
                }}
              >
                <span style={{ fontSize: '1.125rem' }}>{tab.icon}</span>
                <span>{tab.name}</span>
              </button>
            ))}
          </div>
        </div>

        {/* コンテンツエリア */}
        <div style={{ 
          backgroundColor: 'rgba(255, 255, 255, 0.9)',
          borderRadius: '1.5rem',
          padding: '1.5rem',
          boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
          minHeight: '60vh'
        }}>
          {activeTab === 0 && (
            <CareRecordForm 
              onRecordSaved={handleRecordSaved} 
              loading={loading} 
              setLoading={setLoading} 
            />
          )}
          
          {activeTab === 1 && (
            <RecordsList refreshTrigger={refreshTrigger} />
          )}
          
          {activeTab === 2 && (
            <AnalyticsComponent refreshTrigger={refreshTrigger} />
          )}
        </div>
      </div>

      {/* トースト通知 */}
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  );
}